<template>
  <div class="app-wrapper">
    <div class="wrap">
      <wh-header></wh-header>
      <banner @serch="search"></banner>
      <div class="content">
        <router-view xx="xx"></router-view>
      </div>
    </div>

    <wh-footer class="footer"></wh-footer>
  </div>
</template>

<script>
import whFooter from "@/components/whFooter";
import whHeader from "@/components/whHeader";
import banner from "@/components/banner";

export default {
  name: "Layout",
  components: {
    whHeader,
    whFooter,
    banner
  },
  created() {

  },
  computed: {},
  methods: {
    // 搜索
    search() {
      this.$emit('ss')

    }
  },
};
</script>

<style scoped>


html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;

}

.wrap {
  width: 100%;
  min-height: 100vh;
  /*background: lightgreen;*/
}

.content {
  padding-bottom: 307px;
  width: 100%;
  overflow: hidden;
  /*height: 100px;*/
  /*background-color: pink;*/
  /*word-break: break-all;*/
}

.footer {
  /*height: 400px;*/
  margin-top: -307px;
  /*background: pink;*/
}
</style>
